import RecoveryLinkSent from './RecoveryLinkSent'

export default RecoveryLinkSent
